import { render, staticRenderFns } from "./StepFiles.vue?vue&type=template&id=61ae6160&"
import script from "./StepFiles.vue?vue&type=script&lang=js&"
export * from "./StepFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ae6160')) {
      api.createRecord('61ae6160', component.options)
    } else {
      api.reload('61ae6160', component.options)
    }
    module.hot.accept("./StepFiles.vue?vue&type=template&id=61ae6160&", function () {
      api.rerender('61ae6160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/internal/StepFiles.vue"
export default component.exports